// extracted by mini-css-extract-plugin
export default {"card-header":"UserBrand_card-header__6XyyC"};